import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the actionPlans state domain
 */

const selectActionPlansDomain = (state) => state.get("Tracking", initialState)

/**
 * Other specific selectors
 */

export const makeSelectIsLoadingFilters = () =>
  createSelector(selectActionPlansDomain, (state) =>
    state.get("loadingFilters")
  )

export const makeSelectFilters = () =>
  createSelector(selectActionPlansDomain, (state) => state.get("filters"))

export const makeSelectLoadingPlans = () =>
  createSelector(selectActionPlansDomain, (state) => state.get("loadingPlans"))

export const makeSelectPlans = () =>
  createSelector(selectActionPlansDomain, (state) => state.get("plans"))

export const makeSelectSurveys = () =>
  createSelector(selectActionPlansDomain, (state) => state.get("surveys"))

export const makeSelectSidebarAmbassadors = () =>
  createSelector(selectActionPlansDomain, (state) =>
    state.get("sidebar_ambassadors")
  )

export const makeSelectSidebarDivisions = () =>
  createSelector(selectActionPlansDomain, (state) =>
    state.get("sidebar_divisions")
  )

export const makeSelectCountActionPlansDivisions = () =>
  createSelector(selectActionPlansDomain, (state) =>
    state.get("count_action_plans")
  )

export const makeSelectResume = () =>
  createSelector(selectActionPlansDomain, (state) => state.get("resume"))

export const makeSelectIsDownloading = () =>
  createSelector(selectActionPlansDomain, (state) => state.get("isDownloading"))
/**
 * Default selector used by ActionPlans
 */

const makeSelectActionPlans = () =>
  createSelector(selectActionPlansDomain, (substate) => substate.toJS())

export default makeSelectActionPlans
export { selectActionPlansDomain }
